import BackgroundGame from "./Assets/Projects/BackgroundGame.png";
import docsClone from "./Assets/Projects/docsClone.png";
import EarnBazaar from "./Assets/Projects/EarnBazaar.png";
import socialClap from "./Assets/Projects/SocialClap.png";
import TicTacToe from "./Assets/Projects/TicTacToe.png";
import chatify from "./Assets/Projects/chatify.png";
import emotion from "./Assets/Projects/emotion.png";
import vision from "./Assets/Projects/vision.png";
import vstream from "./Assets/Projects/vstream.png";
import vitelanding from "./Assets/Projects/viteLanding.png";

export const majorProjects = [
  {
    id: 1,
    title: "Earn Bazaar",
    description:
      "Earn Bazaar in an online platform which helps Event organisers getting funded. Organisations which wishes to sponsor events and get themselves advertised can list their availability and requirements. Event Organisers can post their funding requirements.",
    ghLink: "https://github.com/DevilsN3st/Earn-Bazaar",
    technology: "React.js, Node.js, Express.js, MongoDB, React-bootstrap, Websockets, WebRTC",
    imgPath: EarnBazaar,
  },
  {
    id: 2,
    title: "Social Clap",
    description:
    "Social Media website to share posts and interact by commenting and reacting on other users post. It is build with React.js, Material-UI, and Firebase. It also hassome advanced features for user convenience like pagination,searching and sorting posts by tags and keywords.",
    ghLink: "https://github.com/DevilsN3st/project-0",
    demoLink: "https://project-0-eta.vercel.app/posts",
    technology: "React.js, Node.js, Express.js, MongoDB, Firebase, Material-UI",
    imgPath: socialClap,
  },
  {
    id: 3,
    title: "VStream",
    description:
    "A Scalable VideoSharing Platform where users can upload and stream their video. HLS( HTTP Live Streaming ) is used to stream videos. FFmpeg is used for codecs conversion. Used Redis to cache the video chunks and Nginx as a reverse proxy server. ",
    ghLink: "https://github.com/DevilsN3st/VStream",
    technology: "React.js, Node.js, Express.js, PostgreSQL, Nginx, Docker, Redis, ffmpeg",
    // demoLink: "https://project-0-eta.vercel.app/posts",
    imgPath: vstream,
  },
];

export const someOtherProjects = [
  {
    id: 1,
    title: "VISION",
    description:
      "A lightweight, front-end only application multilingual website which could provide easily accessible sight tests for rural populations all around the globe who have limited access to medical care. ",
    ghLink: "https://github.com/2022Azure/ImagineCup2022",
    demoLink: "https://visionganges.azurewebsites.net/",
    technology: "React.js, Azure Map",
    imgPath: vision,
  },
  {
    id: 2,
    title: "Google Docs Clone",
    description:
    "Online Editor built similar to Google docs where multiple users can edit the same document in real time. It uses websockets to establish a connection between the users and the server.",
    ghLink: "https://github.com/DevilsN3st/google-docs-clone",
    technology: "React.js, Websockets, React-Quill, React-Markdown",
    imgPath: docsClone,
  },
  {
    id: 3,
    title: "Restaurant Managment System",
    description:
    "A simple web application where a restaurant can manage its customer and their orders. ",
    ghLink: "https://github.com/DevilsN3st/Hotel-Management-using-graphql",
    technology: "React.js, Node.js, Express.js, MongoDB, GraphQL",
    imgPath: chatify,
  },
  {
    id: 4,
    title: "Weather Newsletter app",
    description:
    "A simple webapp where you can get live update about weather of any city across the globe. It also provides a newsletter service. ",
    ghLink: "https://github.com/DevilsN3st/Weather-Newsletter-App",
    technology: "Node.js, Express.js, monkeychimp api, openweathermap api",
    imgPath: emotion,
  },
  {
    id: 5,
    title: "Vite Landing Page",
    description:
    "A Custom made landing page for vite using typescript and css. ",
    ghLink: "https://github.com/DevilsN3st/vite-landing-page",
    technology: "React.js, Typescript, CSS, TailwindCSS",
    imgPath: vitelanding,
  },
];

export const jsGames = [
  {
    id: 1,
    title: "Tic-Tac-Toe",
    description: "A game of Tic-Tac-Toe build using javascript.",
    ghLink: "https://github.com/DevilsN3st/Tic-Tac-Toe",
    demoLink: "https://devilsn3st.github.io/Tic-Tac-Toe/",
    technology: "HTML, CSS, Javascript",
    imgPath: TicTacToe,
  },
  {
    id: 2,
    title: "Background Changer",
    description:
    "A game where you need to guess the color by the displayed RGB values.",
    ghLink: "https://github.com/DevilsN3st/Background-Color-Game",
    demoLink: "https://devilsn3st.github.io/Background-Color-Game/",
    technology: "HTML, CSS, Javascript",
    imgPath: BackgroundGame,
  },
];
